import { render, staticRenderFns } from "./mini-form.vue?vue&type=template&id=28d06ea3&"
import script from "./mini-form.vue?vue&type=script&lang=js&"
export * from "./mini-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports